<!-- 講義情報を編集するためのページ（管理用） -->
<template lang="html">
  <div id="editLecturePage">
    <table>
      <caption>
        講義情報一覧
      </caption>
      <thead>
        <th style="width: 40%;">教師名</th>
        <th style="width: 40%;">生徒名</th>
        <th style="width: auto;"></th>
      </thead>
      <tbody>
        <tr>
          <td>
            <select v-model="lecture.teacher" style="width: 100%;">
              <option v-for="(teacher, index) in sortedTeacherList"
              :key="teacher.user_id"
              :value="teacher.user_id">{{teacher.fullname}}</option><!-- v-for="user in AvailUsers" -->
            </select>
          </td>
          <td>
            <select v-model="lecture.student" style="width: 100%;">
              <option v-for="(student, index) in sortedStudentList"
              :key="student.user_id"
              :value="student.user_id">{{student.fullname}}</option>
            </select>
          </td>
          <td><button @click="registerLecture()">登録</button></td>
        </tr>
        <tr v-for="(lecture, index) in sortedLectureList"
        :key="index" :class="{ evenRow: index % 2 ===0 }">
          <td>{{ lecture.teacher.fullname }}</td>
          <td>{{ lecture.student.fullname }}</td>
          <td><button @click="removeLecture(lecture.id)">×</button></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      lecture: {
        teacher: 0,
        student: 0
      }
    }
  },
  methods: {
    ...mapActions([
      'updateUserList',
      'addLecture',
      'getLectures',
      'deleteLecture'
    ]),
    registerLecture () {
      this.addLecture({
        teacher: parseInt(this.lecture.teacher),
        student: parseInt(this.lecture.student)
      }).then(() => {
        this.getLectures({})
      })
    },
    removeLecture (id) {
      if (window.confirm('登録情報を削除します。\nよろしいですか？')) {
        this.deleteLecture(id)
        .then(() => {
          this.getLectures({})
        })
      }
    },
    sortByKana (userList) {
      return userList.sort((a, b) => {
        return (a.kana > b.kana) ? 1 : (a.kana < b.kana ? -1 : 0)
      })
    }
  },
  computed: {
    ...mapGetters([
      'teacherList',
      'studentList',
      'sortedLectureList'
    ]),
    sortedTeacherList () {
      console.log(this.sortByKana(this.teacherList))
      return this.sortByKana(this.teacherList.filter((user, index, array) => {
        return user.school_id === parseInt(this.$store.state.userInfo.school_id)
      }))
    },
    sortedStudentList () {
      return this.sortByKana(this.studentList.filter((user, index, array) => {
        return user.school_id === parseInt(this.$store.state.userInfo.school_id)
      }))
    }
  },
  mounted () {
    Promise.resolve()
    .then(() => {
      // ユーザリストが空の場合は更新する
      if (this.$store.state.userlist.length === 0) {
        return this.updateUserList()
      } else {
        return Promise.resolve()
      }
    })
    .then(() => {
      this.getLectures({})
    })
  }
}
</script>

<style lang="css" scoped>
table {
  margin: auto;
}
body>tr:hover {
  background-color: #ffcccc
}
.evenRow {
  background-color: #ffffcc
}
</style>



// WEBPACK FOOTER //
// EditLecturePage.vue?be9b2cb8